import React from 'react';

export default function ComponentLog(props) {
  const { clstag, children, ..._props } = props;
  return React.Children.map(children, (ele) => {
    if (!ele) return ele;
    if (!ele.props.clstag && !clstag) return ele;
    let innerClstag = ele.props.clstag || clstag;

    if (!innerClstag.startsWith('pageclick|keycount')) {
      innerClstag = 'pageclick|keycount|' + innerClstag;
    }

    return React.cloneElement(ele, { clstag: `${innerClstag}`, ..._props });
  });
}
